import { CheckoutState } from '../../state';
import {
    getTotalCostsFromGrossValue,
    isAddAttendeesOrder,
} from './typedOrderSelectors';

/**
 * Returns true if the gross value cost of the order is > 0 and it is not an already existing order
 *
 * @param {*} state the application state
 */
export const isPaidOrder = (state: CheckoutState) =>
    getTotalCostsFromGrossValue(state) > 0 && !isAddAttendeesOrder(state);
